//noScroll
class TextAnimation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-strip').each(function(){
      var $t = $(this),
      rows = $.trim($t.html()).split('<br>');

      $t.html('');

      $.each(rows, function(i, val){
        $('<h2 class="row"></h2>').appendTo($t);

        var letters = $.trim(val).split('');

        $.each(letters, function(j, v){
          v = (v == ' ') ? '&nbsp;' : v;
          $('<h2 class="textWord">' + $.trim(v) + '</h2>').appendTo($('.row:last', $t));
        });
      });
    });



    //ターゲット要素をDOMで取得
    const target = document.querySelectorAll(".js-strip");
    target.forEach(el => {


      //オプション
      const options = {
        childList: true,
        characterData: true,
        characterDataOldValue: true,
        attributes: true,
        subtree: true,
      }

      //コールバック関数
      function callback(mutationsList, observer) {
        for(const mutation of mutationsList) {
            // 処理
            mutation.target //ターゲット要素
            mutation.addedNodes //追加されたDOM
            mutation.removedNodes //削除されたDOM

            const elWords = el.querySelectorAll(".textWord")

            let time = mutation.target.classList.contains('js-short') ? '30' : '50';

            for (let i = 0; i < elWords.length; i++) {
              (function(ind) {
                setTimeout(function(){
                  elWords[i].classList.add("animate")
                }, ind * time);
              })(i);
            }

        }
        //ターゲット要素の監視を停止
        obs.disconnect();
      }

      //インスタンス化
      const obs = new MutationObserver(callback);
      //ターゲット要素の監視を開始
      obs.observe(el, options);
    })







  }
}
